import { WineWidgetModel } from '../../models/WineWidgetModel';
import { AvailableText, NotAvailableText } from './components/OrderableText';
import { WineDiscount } from './components/WineDiscount';

interface WineContentProps {
  wine: WineWidgetModel;
}

/**
 * The WineInfo component renders the title, manufacturer name, price, discount, and
 * availability of the wine.
 *  @param wine - The wine object.
 * @returns a JSX fragment. It is rendering the title, manufacturer name, price, discount, and
 */
export const WineInfo = ({ wine }: WineContentProps) => {
  return (
    <>
      <div className='w-full h-fit flex flex-col'>
        <div className='flex gap-[8px] items-center'>
          <h1 className='font-semibold text-black text-[18px] font-body truncate'>{wine.title}</h1>
          <span className='font-semibold text-black text-[18px] font-body flex-grow'>{wine.productYear}</span>
        </div>
      </div>
      <div className={`flex justify-between mb-[12px] w-full ${wine.showEurPrice ? 'items-center' : 'lg:mt-[12px] items-start'}`}>
        <WineDiscount wine={wine} />
        <div className={`flex items-center ${wine.showEurPrice ? 'mb-[24px]' : 'mb-0'} `}>{wine.availableQuantity > 0 ? <AvailableText /> : <NotAvailableText />}</div>
      </div>
    </>
  );
};
